import React from 'react';
import { Col } from '../RowCol';
import styles from '../../style';

type Props = {
	name: string;
	author?: string;
	onClick?: () => void;
};

const CategorySquare: React.FC<Props> = ({
	name,
	author,
	onClick = () => undefined,
}) => {
	return (
		<Col
			onClick={onClick}
			style={{
				backgroundColor: styles.squareBackgroundColor,
				width: styles.squareWidth,
				height: styles.squareHeight,
				color: styles.categoryColor,
				fontSize: styles.categoryFontSize,
				fontFamily: styles.categoryFont,
				justifyContent: 'center',
				alignItems: 'center',
				textTransform: 'uppercase',
				textShadow: styles.shadow0,
				textAlign: 'center',
			}}
		>
			<Col fill center>
				{name}
			</Col>
			{author && (
				<Col style={{
					color: styles.dollarColor,
					fontSize: styles.categoryAuthorFontSize,
					fontFamily: styles.categoryAuthorFont,
				}}>
					{`${author}`}
				</Col>
			)}
		</Col>
	);
};

export default CategorySquare;
